import { useTheme } from '../../theme/ThemeContext';
import { buildNativeSelectCaretStyles, CARET_RIGHT_PADDING } from '../nativeSelectCaretStyles';
export const useTimezonePickerStyles = ({
  isDisabled,
  width
}) => {
  const theme = useTheme();
  const isAuto = width === 'auto';
  const selectStyle = Object.assign({
    display: isAuto ? 'inline-block' : 'block',
    width: isAuto ? 'auto' : '100%',
    maxWidth: '100%',
    padding: `${theme.spacing['200']} ${CARET_RIGHT_PADDING}px ${theme.spacing['200']} ${theme.spacing['200']}`,
    fontSize: theme.fontSizes.lg,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: theme.components.select.borderRadius,
    boxSizing: 'border-box',
    backgroundColor: theme.colors.background,
    color: isDisabled ? theme.colors.textDisabled : theme.colors.text
  }, buildNativeSelectCaretStyles(theme.colors.textSecondary));
  return {
    selectStyle
  };
};